module.exports = __webpack_public_path__ + "img/598.da8194b1.jpg";